import React from 'react';
import { Shield, Clock, TrendingDown, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function ValueProps() {
  const features = [{
    icon: Zap,
    title: 'Electric Powered',
    description: 'No more hand pumping. Consistent 60 PSI pressure from start to finish.',
    color: 'from-[#FF6B35] to-[#FFA500]'
  }, {
    icon: Clock,
    title: 'Save Time',
    description: 'Complete jobs 50% faster with continuous spray and extended reach.',
    color: 'from-[#FFA500] to-[#FFD700]'
  }, {
    icon: Shield,
    title: 'Built to Last',
    description: 'Chemical-resistant seals and heavy-duty construction for years of use.',
    color: 'from-[#10B981] to-[#059669]'
  }, {
    icon: TrendingDown,
    title: 'Lower Costs',
    description: 'Reduce labor time and increase efficiency on every job site.',
    color: 'from-[#3B82F6] to-[#2563EB]'
  }];
  return <section id="features" className="py-24 bg-[#0f0f0f]" data-id="element-217">
      <div className="container mx-auto px-4" data-id="element-218">
        <div className="text-center mb-16" data-id="element-219">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-220">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-221">
              Why Professionals Choose Us
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-222">
              Engineered for the demands of mold remediation, water restoration,
              and industrial applications.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-223">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="group relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-800 hover:border-gray-700 transition-all duration-300 hover:-translate-y-2" data-id="element-224">
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`} data-id="element-225">
                <feature.icon className="w-7 h-7 text-white" data-id="element-226" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-227">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-228">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}